import StockTakeBoxListTable from './stockTakeBoxListTable.container';

export default StockTakeBoxListTable